import { useFetch } from "@/lib/hooks";
import { TIPI, tipoOf } from "@/lib/calendar";
import { AppointmentsWorkspace } from "@/components/calendar/AppointmentsWorkspace";

export const ClientCalendar = ({ clientId, users }) => {
  const { data, reload } = useFetch(`/appointments?client_id=${clientId}`);
  const legend = TIPI.map((t) => (
    <span key={t.value} className="inline-flex items-center gap-1.5 text-xs font-semibold text-slate-600"><span className="h-2.5 w-2.5 rounded-full" style={{ background: t.color }} />{t.label}</span>
  ));
  return (
    <div data-testid="client-calendar">
      <AppointmentsWorkspace appointments={data || []} reload={reload} colorOf={(a) => tipoOf(a.tipo).color}
        clientId={clientId} users={users} toolbar={legend} />
    </div>
  );
};
